'use strict';

const isSVGTag = (tag) => typeof tag === "string" && tag.toLowerCase() === "svg";

exports.isSVGTag = isSVGTag;
//# sourceMappingURL=is-svg-tag.cjs.map
